module.exports = __webpack_public_path__ + "static/media/Drivers-Icon.118428a4.svg";